import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { LoadingIndicator } from "../src/components/common/LoadingIndicator";
import { DrawerContextProvider } from "./components/ReactContext/DrawerContext";
import { ChakraProvider } from "@chakra-ui/react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Suspense fallback={<LoadingIndicator />}>
    <React.StrictMode>
      <DrawerContextProvider>
        <ChakraProvider>
          <App />
        </ChakraProvider>
      </DrawerContextProvider>
    </React.StrictMode>
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
